import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { bindActionCreators, Dispatch } from 'redux';
import { enqueueSnackbarCustomMessage } from 'actions/Snackbar/resetSnackbar';
import { connectWithRouter } from 'helpers/connectWithRouter';
import React, { useCallback, useEffect, useState } from 'react';
import IntegrationFormModal from './IntegrationFormModal';
import IntegrationTable from './IntegrationTable';
import { API_URL } from '../../../configs/Api';
import { getHeaders } from '../../../middleware/Api';
const styles = require('./styles.pcss');
interface Props {
  organizationId?: string;
  organizationName: string;
  enqueueSnackbarCustomMessage: Function;
}

function IntegrationsDisplay(props: Props) {
  const [popupOpen, setPopupOpen] = useState(false);
  const [integrations, setIntegrations]: [any[], Function] = useState([]);
  let isMounted: boolean;
  useEffect(() => {
    isMounted = true;
    fetchIntegrations();
  }, []);
  const fetchIntegrations = useCallback(async function () {
    try {
      const res = await (
        await fetch(API_URL + `integrations/${props.organizationId}`, {
          method: 'get',
          headers: getHeaders(),
        })
      ).json();
      if (!isMounted) return;
      switch (res.type) {
        case 'data':
          setIntegrations(res.payload ?? []);
          return;
        default:
          throw new Error('An error occurred fetching integrations.');
      }
    } catch (e) {
      props.enqueueSnackbarCustomMessage(
        'An error occurred fetching integrations.',
        'error',
      );
    }
    return () => (isMounted = false);
  }, []);

  const addIntegration = useCallback(
    function (integration: any) {
      setIntegrations(integrations.concat([integration]));
    },
    [integrations],
  );
  return (
    <Paper className={styles.cardContainer}>
      <div>
        {integrations.length ? (
          <IntegrationTable
            integrations={integrations}
            setIntegrations={setIntegrations}
            organizationId={props.organizationId}
            organizationName={props.organizationName}
          />
        ) : (
          <div className={styles.emptyTable}>no integration data found</div>
        )}
      </div>
      <Button
        size="small"
        className={styles.addButton}
        variant="contained"
        color="primary"
        onClick={() => setPopupOpen(true)}
      >
        Add Integration
      </Button>
      <IntegrationFormModal
        popupOpen={popupOpen}
        closePopup={() => setPopupOpen(false)}
        organizationId={props.organizationId}
        orgName={props.organizationName}
        addIntegration={addIntegration}
      />
    </Paper>
  );
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      enqueueSnackbarCustomMessage,
    },
    dispatch,
  );
}

export default connectWithRouter(null, mapDispatchToProps)(IntegrationsDisplay);
